import moment from 'moment'
import { func, object, string, oneOf } from 'prop-types'
import { kuiperClassNames } from '../../../utils'
import Day from '../Day'

import './styles.scss'

const renderDay = (
  allowable,
  startDay,
  refDate,
  selected,
  onDaySelect,
  classPrefix,
  dayFormat
) => (
  <Day
    allowable={allowable}
    key={startDay}
    classPrefix={classPrefix}
    date={startDay.clone()}
    refDate={refDate}
    onClick={onDaySelect}
    format={dayFormat}
    selected={startDay.isSame(selected, 'day')}
  />
)

const days = (
  allowable,
  date,
  refDate,
  selected,
  onDaySelect,
  classPrefix,
  dayFormat
) => {
  const startDay = moment(date)
  const daysOut = []

  for (let index = 0; index < 7; index += 1) {
    daysOut.push(
      renderDay(
        allowable,
        startDay,
        refDate,
        selected,
        onDaySelect,
        classPrefix,
        dayFormat
      )
    )

    startDay.add(1, 'days')
  }

  return daysOut
}

const Week = ({
  allowable = () => true,
  className,
  classPrefix = '',
  date = moment().startOf('week'),
  dayFormat = 'D',
  onDaySelect,
  refDate = moment().add(2, 'weeks'),
  selected,
  startOfWeek = 0,
}) => {
  const startDate = date.add(startOfWeek, 'days')
  const classes = kuiperClassNames(`${classPrefix}-week`, className, {
    sameWeek: date.isSame(refDate, 'week'),
  })

  return (
    <tr className={classes}>
      {days(
        allowable,
        startDate,
        refDate,
        selected,
        onDaySelect,
        classPrefix,
        dayFormat
      )}
    </tr>
  )
}

Week.propTypes = {
  allowable: func,
  className: string,
  classPrefix: string,
  date: object,
  dayFormat: string,
  onDaySelect: func,
  refDate: object,
  selected: object,
  startOfWeek: oneOf([0, 1, 2, 3, 4, 5, 6]),
}

export default Week
